<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <span class="no-redirect" style="float: left"><i class="location-icon el-icon-location-outline"></i>您的位置 ：</span>
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="item in levelList" v-if="item.meta.title" :key="item.path">
        <!-- <span v-if="item.redirect==='noredirect' || index == levelList.length - 1" class="no-redirect">{{item.meta.title}}</span>
        <router-link v-else :to="item.redirect || '/' + item.path">{{item.meta.title}}</router-link> -->
        <span class="no-redirect">{{item.meta.title}}</span>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import pathToRegexp from 'path-to-regexp'

export default {
  data () {
    return {
      levelList: null
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  },
  created () {
    // console.log(this.$route.matched)
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb () {
      let matched = this.$route.matched.filter(item => {
        return item.name
      })
      this.levelList = matched
    },
    pathCompile (path) {
      const { params } = this.$route
      var toPath = pathToRegexp.compile(path)
      return toPath(params)
    },
    handleLink (item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(this.pathCompile(path))
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
// @import 'src/styles/variables.scss';
  .app-breadcrumb.el-breadcrumb {
    line-height: 36px;
    padding:0 10px;
    color: #a69f84 !important;
    background: #f7f7f4;
    border-bottom:1px solid rgba(236,240,241,1);
    .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link{
      font-weight: normal;
    }
    .no-redirect{
      // color: $fontActiveColor;
    }
    .location-label{
      font-size: 12px;
      cursor: default;
    }
    .location-icon{
      font-size: 20px;
      vertical-align: text-top;
      margin-left: 10px;
      margin-right: 6px;
    }
    // .no-redirect {
    //   color: #97a8be;
    //   cursor: text;
    // }
  }

</style>



// WEBPACK FOOTER //
// src/views/home/Breadcrumb.vue